var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconIpBlcok = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "url(#paint0_linear_22480_154332)",
    stroke: "url(#paint1_linear_22480_154332)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 22.5C25.75 22.78 25.53 23 25.25 23C23.74 23 22.48 24.12 22.28 25.58C22.25 25.82 22.03 26 21.79 26C21.49 26 21.25 25.73 21.29 25.43C21.4193 24.5644 21.8269 23.7645 22.4511 23.1511C23.0754 22.5377 23.8823 22.1442 24.75 22.03V11.25C24.75 10.9185 24.6183 10.6005 24.3839 10.3661C24.1495 10.1317 23.8315 10 23.5 10C23.1685 10 22.8505 10.1317 22.6161 10.3661C22.3817 10.6005 22.25 10.9185 22.25 11.25V18.5C22.25 18.78 22.03 19 21.75 19C21.47 19 21.25 18.78 21.25 18.5V9.25C21.25 8.91848 21.1183 8.60054 20.8839 8.36612C20.6495 8.1317 20.3315 8 20 8C19.6685 8 19.3505 8.1317 19.1161 8.36612C18.8817 8.60054 18.75 8.91848 18.75 9.25V18.5C18.75 18.78 18.53 19 18.25 19C17.97 19 17.75 18.78 17.75 18.5V10.75C17.75 10.4185 17.6183 10.1005 17.3839 9.86612C17.1495 9.6317 16.8315 9.5 16.5 9.5C16.1685 9.5 15.8505 9.6317 15.6161 9.86612C15.3817 10.1005 15.25 10.4185 15.25 10.75V19.5C15.25 19.78 15.03 20 14.75 20C14.47 20 14.25 19.78 14.25 19.5V13.75C14.25 13.4185 14.1183 13.1005 13.8839 12.8661C13.6495 12.6317 13.3315 12.5 13 12.5C12.6685 12.5 12.3505 12.6317 12.1161 12.8661C11.8817 13.1005 11.75 13.4185 11.75 13.75V23.75C11.75 28.31 15.44 32 20 32C24.56 32 28.25 28.31 28.25 23.75V17.25C28.25 16.9185 28.1183 16.6005 27.8839 16.3661C27.6495 16.1317 27.3315 16 27 16C26.6685 16 26.3505 16.1317 26.1161 16.3661C25.8817 16.6005 25.75 16.9185 25.75 17.25V22.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22480_154332",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22480_154332",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconIpBlcok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_ip_blcok.83ba90241e4facb9d9f6d60a8a381d51.svg";